import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppData } from './app-data.service';
import { JSEncrypt } from 'jsencrypt';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private userToken: string = '';

  publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+SJMkWLJ/NiKL6NRsIsjvdzyu\navEnbv+WzsHENko5AFGshfAbmjp19AJ/iaW0Jg1xu0XeEigT4UtnkTEuho8lEgRy\nULltedWgUprEGIwIHnAbJ1GJZCe3NtasaaleOPU67UkkQ9fKGXMujiCUTq1dTnd7\ntOosAeWrPpnOnx6gyQIDAQAB\n';

  privateKey = '' +
  'MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAL5IkyRYsn82Iovo' +
  '\n' +
  '1GwiyO93PK5q8Sdu/5bOwcQ2SjkAUayF8BuaOnX0An+JpbQmDXG7Rd4SKBPhS2eR' +
  '\n' +
  'MS6GjyUSBHJQuW151aBSmsQYjAgecBsnUYlkJ7c21qxpqV449TrtSSRD18oZcy6O' +
  '\n' +
  'IJROrV1Od3u06iwB5as+mc6fHqDJAgMBAAECgYEAvHjEDX8xJaFoLG4sYQM/RTk0' +
  '\n' +
  'SIoyXF2sGSKneAJSGA2B2EE95wknGIfdJZggIcSDEoBsnp4bRj2j42xDa5LqGhRu' +
  '\n' +
  'm9yY2R6W64BUs2PcHXAhWMCU+vqfsV/dpjB/1P7ix1ETqDNhaC6pkWDvsgGYg8jm' +
  '\n' +
  'csqaP24fiwXB2biUOsUCQQD4WVmSbZfbejrGfMAQNvpAAfg+XhRS8hzAW3bQnU5A' +
  '\n' +
  'Jrt8sZUlX6WZNAkZMP1KgP3RVoJMdVGbtVWgckBsxndjAkEAxCVHy5h9c1q0xq1T' +
  '\n' +
  'ERvogD8lrMA40f0T53YiMKsGU523hjk6RvYTaJTN30lUduwatFIOKOgo+gsuDZHS' +
  '\n' +
  'U7ds4wJAWjoMAtjyLPjxVZ+JH9r5fDu69t2zQJdZvsD8H7qm7UOlJh5Wc2eWgFyZ' +
  '\n' +
  'WZ+kxmaq0F0/pYuSBKIS4+HeaiaIxQJBAKZj5bq9ujYgDVi48c2CukIIz4HzcoAY' +
  '\n' +
  'S0k/upNEkdJe6a+wXlKSLza5fMdc4o0bjy/GqAJlp1UuJLwYJq8j2/cCQQCTMan4' +
  '\n' +
  'pUAKEhydxTXMCnSQCmsgTy9NCiVa4ihAl2gKPAiU+ABmd3yuH/qYI80waObn8kE4' +
  '\n' +
  'a9L1qtusIcVbumSb';

  constructor(private _AppData: AppData) {}

  // ---------------- AES helpers (kept as in your original) ----------------
  aesEncrypt(data: any) {
    const key = 'hvis99blq40iy1udcrxy3zgmhwl7fjan'; // length 32
    const iv = '817yv94fqao9nmjm';
    const cipher = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
    });
    return encodeURIComponent(cipher.toString());
  }

  aesDecrypt(data: any) {
    const key = 'hvis99blq40iy1udcrxy3zgmhwl7fjan'; // length 32
    const iv = '817yv94fqao9nmjm';
    const cipher = CryptoJS.AES.decrypt(decodeURIComponent(data), CryptoJS.enc.Utf8.parse(key), {
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
    });
    return cipher.toString(CryptoJS.enc.Utf8);
  }

  // ---------------- RSA long string helpers (migrated from old library) ----------------

  // Base64 map / helpers (converted from original code)
  private readonly b64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  private readonly b64pad = '=';

  private hex2b64(h: string): string {
    let i: number;
    let c: number;
    let ret = '';
    for (i = 0; i + 3 <= h.length; i += 3) {
      c = parseInt(h.substring(i, i + 3), 16);
      ret += this.b64map.charAt(c >> 6) + this.b64map.charAt(c & 63);
    }
    if (i + 1 === h.length) {
      c = parseInt(h.substring(i, i + 1), 16);
      ret += this.b64map.charAt(c << 2);
    } else if (i + 2 === h.length) {
      c = parseInt(h.substring(i, i + 2), 16);
      ret += this.b64map.charAt(c >> 2) + this.b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0) {
      ret += this.b64pad;
    }
    return ret;
  }

  private BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
  private int2char(n: number) {
    return this.BI_RM.charAt(n);
  }

  private b64tohex(s: string) {
    let ret = '';
    let i: number;
    let k = 0; // b64 state, 0-3
    let slop = 0;
    for (i = 0; i < s.length; ++i) {
      if (s.charAt(i) === this.b64pad) {
        break;
      }
      const v = this.b64map.indexOf(s.charAt(i));
      if (v < 0) {
        continue;
      }
      if (k === 0) {
        ret += this.int2char(v >> 2);
        slop = v & 3;
        k = 1;
      } else if (k === 1) {
        ret += this.int2char((slop << 2) | (v >> 4));
        slop = v & 0xf;
        k = 2;
      } else if (k === 2) {
        ret += this.int2char(slop);
        ret += this.int2char(v >> 2);
        slop = v & 3;
        k = 3;
      } else {
        ret += this.int2char((slop << 2) | (v >> 4));
        ret += this.int2char(v & 0xf);
        k = 0;
      }
    }
    if (k === 1) {
      ret += this.int2char(slop << 2);
    }
    return ret;
  }

  // encrypts long text with a public key and returns base64 result (same as old lib)
  encryptPublicLong(text: string, publicKey: string) {
    const rsa = new JSEncrypt();
    rsa.setPublicKey(publicKey);
    const key: any = (rsa as any).getKey();
    let ct = '';

    // Build split indices based on byte length / 117 limit
    const bytes: number[] = [];
    bytes.push(0);
    let byteNo = 0;
    const len = text.length;
    let temp = 0;
    for (let i = 0; i < len; i++) {
      const c = text.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10FFFF) {
        byteNo += 4;
      } else if (c >= 0x000800 && c <= 0x00FFFF) {
        byteNo += 3;
      } else if (c >= 0x000080 && c <= 0x0007FF) {
        byteNo += 2;
      } else {
        byteNo += 1;
      }
      if ((byteNo % 117) >= 114 || (byteNo % 117) === 0) {
        if (byteNo - temp >= 114) {
          bytes.push(i);
          temp = byteNo;
        }
      }
    }

    if (bytes.length > 1) {
      for (let i = 0; i < bytes.length - 1; i++) {
        let strPart: string;
        if (i === 0) {
          strPart = text.substring(0, bytes[i + 1] + 1);
        } else {
          strPart = text.substring(bytes[i] + 1, bytes[i + 1] + 1);
        }
        const t1 = key.encrypt(strPart);
        ct += t1;
      }
      if (bytes[bytes.length - 1] !== text.length - 1) {
        const lastStr = text.substring(bytes[bytes.length - 1] + 1);
        ct += key.encrypt(lastStr);
      }
      return this.hex2b64(ct);
    }
    const t = key.encrypt(text);
    return this.hex2b64(t);
  }

  // decrypts base64 encrypted long text using private key; returns plaintext or false
  decryptPrivateLong(text: string, privateKey: string) {
    const rsa = new JSEncrypt();
    rsa.setPrivateKey(privateKey);
    const key: any = (rsa as any).getKey();

    text = this.b64tohex(text);
    const maxLength = ((key.n.bitLength() + 7) >> 3);
    try {
      if (text.length > maxLength) {
        let ct1 = '';
        const lt = text.match(/.{1,256}/g);
        if (lt) {
          lt.forEach((entry: string) => {
            const t1 = key.decrypt(entry);
            ct1 += t1;
          });
        }
        return ct1;
      }
      const y = key.decrypt(text);
      return y;
    } catch (ex) {
      return false;
    }
  }

  // ---------------- existing wrapper methods (keeps your API) ----------------

  jsEncrypt(data: any) {
    return this.encryptPublicLong(JSON.stringify(data), this.publicKey);
  }

  jsDecrypt(data: any) {
    return this.decryptPrivateLong(data, this.privateKey);
  }

  // ---------------- your CryptoJSAesJson and Encrypt/Decrypt methods ----------------
  private CryptoJSAesJson = {
    stringify: function (cipherParams: any) {
      const vbJsonString: any = {
        hv: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)
      };
      if (cipherParams.iv) {
        vbJsonString['iv'] = cipherParams.iv.toString();
      }
      if (cipherParams.salt) {
        vbJsonString['s'] = cipherParams.salt.toString();
      }
      return JSON.stringify(vbJsonString);
    },
    parse: function (jsonStr: any) {
      const vbJsonParse = JSON.parse(jsonStr);
      const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(vbJsonParse.hv)
      });
      if (vbJsonParse.iv) {
        cipherParams['iv'] = CryptoJS.enc.Hex.parse(vbJsonParse.iv);
      }
      if (vbJsonParse['s']) {
        cipherParams.salt = CryptoJS.enc.Hex.parse(vbJsonParse.s);
      }
      return cipherParams;
    }
  }

  Encrypt = (data: any) => {
    let userToken: any;
    const userData = this._AppData.getUserDetails();
    if (userData) {
      userToken = userData.remembertoken;
    }
    return CryptoJS.AES.encrypt(JSON.stringify(data), userToken ? userToken.slice(-10) : 'waAgexGyN', { format: this.CryptoJSAesJson }).toString();
  }

  Decrypt = (data: any, useStaticToken: boolean = false) => {
    let userToken: any;
    const userData = this._AppData.getUserDetails();
    if (userData) {
      userToken = userData?.remembertoken?.slice(-10);
    }
    if (useStaticToken) {
      userToken = 'waAgexGyN';
    }
    if (!userToken) {
      userToken = 'waAgexGyN';
    }
    return JSON.parse(CryptoJS.AES.decrypt(JSON.stringify(data), userToken, { format: this.CryptoJSAesJson }).toString(CryptoJS.enc.Utf8));
  }
}
